// import "./uiSlider.scss";
import React from 'react';
import Slider from '@mui/material/Slider';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';

const theme = createTheme({
  direction: 'ltr',
});

const StyledSlider = styled(Slider)(() => ({
  '& .MuiSlider-thumb': {
    color: '#0C395A',
  },
  '& .Mui-disabled': {
    color: 'silver',
    cursor: 'not-allowed',
  },
}));

const UiSlider = (props) => {
  return (
    <ThemeProvider theme={theme}>
      <StyledSlider size='medium' {...props} />
    </ThemeProvider>
  );
};

export default UiSlider;
